
import React, { useContext } from 'react';
import styled, { css } from 'styled-components';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import RestoreFromTrashOutlinedIcon from '@material-ui/icons/RestoreFromTrashOutlined';
import { InputNumberWidget } from 'form/InputWidget';
import {FormContext} from "../../core/FormProvider";
import { grey } from "@material-ui/core/colors";
import {Chip} from "@material-ui/core";


const Index = styled.div`
  border: 1px solid #333333;
  border-radius: 2px;
  font-weight: bold;
  text-align: center;
  line-height: 24px;
`;

const StyledTariffPointServiceForm = styled.div`
  width: 580px;
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 34px 1fr 120px 20px;
  margin-bottom: 20px;
  align-items: center;
  
  .tariffication_display {
    font-size: 12px;
    color: #828282;
  }
  
  ${(props) => props.isDeleted && css`
    color: ${grey[500]};
  `};
`;


export default function TariffServiceForm({fieldPath, tariffService, index}) {
  const formContext = useContext(FormContext);
  const isDeleted = tariffService.is_delete === true;

  const removePointService = () => {
    if (tariffService.id) {
      formContext.setValue(`${fieldPath}.${index}.is_delete`, true);
    }
    else {
      formContext.removeArrayValue(fieldPath, index);
    }
  };

  const handleChange = (name, value) => {
    formContext.setValue(`${fieldPath}.${index}.${name}`, value)
  };

  return (
    <StyledTariffPointServiceForm isDeleted={isDeleted}>
      <div>
        <Index>{index + 1}</Index>
      </div>
      <div>
        <div>{tariffService.service.label}</div>
        <div className={'tariffication_display mt-2'}>
          {tariffService.service.tariffication_display}
          {', '}
          {tariffService.service.financial_schema_display}
        </div>
      </div>
      <div>
        <InputNumberWidget
          disabled={isDeleted}
          value={tariffService.cost}
          label={'Цена, ₽'}
          size={'small'}
          onChange={(value) => handleChange('cost', value)}
          className={'mb-0'}
          InputLabelProps={{
            shrink: true
          }}
        />
      </div>
      <div>
        {isDeleted && (
          <IconButton tabIndex={'-1'} size={'small'} onClick={() => handleChange('is_delete', false)}>
            <RestoreFromTrashOutlinedIcon />
          </IconButton>
        )}
        {!isDeleted && (
          <IconButton tabIndex={'-1'} size={'small'} onClick={() => removePointService()}>
            <ClearIcon />
          </IconButton>
        )}
      </div>
      {isDeleted && (
        <div><Chip size="small" label="Услуга будет удалена" /></div>
      )}
    </StyledTariffPointServiceForm>
  )
}
